
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { 
  ExternalLink
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { getRewardfulDashboardUrl } from "@/utils/rewardfulUtils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const ReferralLinkCard = () => {
  const { user } = useAuth();
  
  const openRewardfulDashboard = () => {
    const dashboardUrl = getRewardfulDashboardUrl();
    window.open(dashboardUrl, '_blank', 'noopener,noreferrer');
  };
  
  return (
    <Card>
      <CardContent className="p-4 space-y-4">
        <div className="space-y-2">
          <h3 className="text-lg font-medium">Programa de Referidos</h3>
          <p className="text-sm text-gray-600">
            Accede directamente al panel de Rewardful para gestionar tu cuenta de afiliado, ver tus estadísticas y solicitar pagos.
          </p>
        </div>
        
        {/* Botón del dashboard de Rewardful con información adicional */}
        <div className="pt-4 border-t mt-2">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="default"
                  onClick={openRewardfulDashboard}
                  className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white hover:opacity-90"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  Acceder al panel de Rewardful
                </Button>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p> Registrate e inicia sesión con el mismo correo que usas en Guía Vegana</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          <div className="text-xs text-gray-500 mt-2 space-y-1">
            <p className="text-center">
              Accede al panel de Rewardful para ver tus enlaces de referido, estadísticas y solicitar pagos
            </p>
            <p className="text-center font-medium">
              Registate y luego inicia sesión con el mismo correo electrónico que usas en Guía Vegana
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralLinkCard;
